import { render } from "./CheckMarkSvg.vue?vue&type=template&id=41a13a30"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__